export const updateContract = async (client,contractId, body,schema="pure") => {
  return await client.update(contractId, body,schema)
};